import { Box, BoxProps, Typography } from "@mui/material";
import { paletteVar } from "@platform/design-system";

interface CensusTitleProps extends BoxProps {
  title: string;
}

const CensusTitle = ({
  title,
  ...rest
}: CensusTitleProps): React.JSX.Element => (
  <Box
    bgcolor={paletteVar("surfaces-primary", "#EFF8FB")}
    px={2}
    py={1}
    mb={3}
    {...rest}
  >
    <Typography variant="bodyBold">{title}</Typography>
  </Box>
);
export default CensusTitle;
